module.exports = __webpack_public_path__ + "img/cfb3973.png";